import * as React from 'react';
import { ContainerEmailPreview } from './ContainerEmailPreview';

interface FollowUpPreviewI {
	caseName: string;
	followUpName: string;
	userName?: string;
	emailMessage: string;
}

export const FollowUpPreview: React.FC<FollowUpPreviewI> = ({
	caseName,
	followUpName,
	userName = `[User's Name]`,
	emailMessage,
}) => {
	const [htmlContent, setHtmlContent] = React.useState<string>('');
	const [stylesContent, setStylesContent] = React.useState<string>('');

	React.useEffect(() => {
		const fetchHtml = async () => {
			// Get the content of the HTML file
			const response = await fetch('/email-templates/client/follow-up.html');
			const html = await response.text();

			// Create a DOM to render the content
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');

			// Extraer el div con id="principalContent"
			const contentElement = doc.querySelector('#principalContent');

			if (contentElement) {
				// Replace Follow-up Name
				contentElement.innerHTML = contentElement.innerHTML.replace(
					'Follow-up Name',
					followUpName
				);

				// Replace [Case Name]
				contentElement.innerHTML = contentElement.innerHTML.replace(
					'[Case Name]',
					caseName
				);

				// Replace [User's Name]
				contentElement.innerHTML = contentElement.innerHTML.replace(
					`[User's Name]`,
					userName
				);

				// Replace [Description]
				contentElement.innerHTML = contentElement.innerHTML.replace(
					'Email Message',
					emailMessage
				);

				// Deshabilitar todos los enlaces <a> y aplicar estilos
				const links = doc.querySelectorAll('a');
				links.forEach((link) => {
					link.removeAttribute('href');
					link.style.opacity = '0.7';
					link.style.pointerEvents = 'none';
					link.style.cursor = 'not-allowed';
				});
			}
			setHtmlContent(contentElement?.outerHTML || '');

			// Extract styles from file
			const styleElements = doc.querySelectorAll('style');
			let extractedStyles = '';
			styleElements.forEach((style) => {
				extractedStyles += style.textContent;
			});
			setStylesContent(extractedStyles);
		};

		fetchHtml();
	}, []);

	return (
		<ContainerEmailPreview type="email">
			{/* Inject the extracted styles and add flex so it looks good in preview */}
			<style>
				{`
					${stylesContent}
					.centerAlign {
						text-align: center;
						margin: 0 auto 0 auto;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
					}
				`}
			</style>
			<div
				className="mb-10"
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		</ContainerEmailPreview>
	);
};
